import {atom} from 'recoil';


export const rolesState = atom ({
    key: 'rolesState',
    default: null
});